(function () {
  if (window.__dillJohanEnquiryRecovery20260526) return;
  window.__dillJohanEnquiryRecovery20260526 = true;

  var quoteMessage = 'Hi Dill & Johan, I would like a white-glove delivery quote for the pieces in my cart.';

  function setComposerMessage(root, message) {
    if (!root || !message) return;
    var field = root.querySelector('textarea, input[type="text"], [contenteditable="true"], .composer-bar__message-text');
    if (!field) return;
    if (field.isContentEditable) {
      field.textContent = message;
    } else {
      field.value = message;
    }
    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    field.focus();
  }

  function openShopifyInbox(message) {
    var chat = document.querySelector('inbox-online-store-chat');
    if (!chat) {
      window.location.href = '/pages/contact';
      return;
    }

    function openFromRoot(root) {
      if (!root) return false;
      var toggle = root.querySelector('button[data-spec="toggle-button"]');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
        toggle.click();
      }
      window.setTimeout(function () { setComposerMessage(root, message); }, 450);
      window.setTimeout(function () { setComposerMessage(root, message); }, 1100);
      return true;
    }

    if (chat.shadowRoot && openFromRoot(chat.shadowRoot)) return;
    chat.click();
    window.setTimeout(function () {
      if (chat.shadowRoot) openFromRoot(chat.shadowRoot);
    }, 700);
  }

  function findTrigger(target) {
    return target && target.closest ? target.closest('[data-dj-open-chat]') : null;
  }

  document.addEventListener('click', function (event) {
    var trigger = findTrigger(event.target);
    if (!trigger) return;
    event.preventDefault();
    openShopifyInbox(trigger.getAttribute('data-dj-chat-message') || quoteMessage);
  });

  function hasCartSurface() {
    return document.querySelector('.cart, .cart__summary, .cart-drawer__summary, cart-drawer');
  }

  function createModal() {
    if (document.querySelector('.dj-cart-guidance-modal')) return document.querySelector('.dj-cart-guidance-modal');
    var modal = document.createElement('div');
    modal.className = 'dj-cart-guidance-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-label', 'White-glove delivery guidance');
    modal.innerHTML = [
      '<button type="button" class="dj-cart-guidance-modal__close" aria-label="Close">&times;</button>',
      '<span class="dj-cart-guidance-modal__eyebrow">Delivery guidance</span>',
      '<strong>Unsure about freight or placement?</strong>',
      '<p>For larger pieces, the studio can confirm white-glove delivery before you order.</p>',
      '<button type="button" class="dj-cart-guidance-modal__cta" data-dj-open-chat data-dj-chat-message="' + quoteMessage.replace(/"/g, '&quot;') + '">Contact the studio</button>'
    ].join('');
    modal.querySelector('.dj-cart-guidance-modal__close').addEventListener('click', function () {
      modal.classList.remove('is-visible');
      try { sessionStorage.setItem('dj-cart-guidance-dismissed', '1'); } catch {}
    });
    document.body.appendChild(modal);
    return modal;
  }

  function showModal() {
    try {
      if (sessionStorage.getItem('dj-cart-guidance-dismissed') || sessionStorage.getItem('dj-cart-guidance-shown')) return;
      sessionStorage.setItem('dj-cart-guidance-shown', '1');
    } catch {}
    createModal().classList.add('is-visible');
  }

  function initCartGuidance() {
    if (!hasCartSurface()) return;
    var checkoutArea = document.querySelector('.cart__summary, .cart-drawer__summary, [name="checkout"]');
    var hoverTimer = null;
    if (checkoutArea) {
      checkoutArea.addEventListener('mouseenter', function () {
        hoverTimer = window.setTimeout(showModal, 3200);
      });
      checkoutArea.addEventListener('mouseleave', function () {
        if (hoverTimer) window.clearTimeout(hoverTimer);
      });
      checkoutArea.addEventListener('focusin', function () {
        hoverTimer = window.setTimeout(showModal, 3200);
      });
      checkoutArea.addEventListener('focusout', function () {
        if (hoverTimer) window.clearTimeout(hoverTimer);
      });
    }
    if (document.body.classList.contains('template--cart')) {
      window.setTimeout(showModal, 18000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartGuidance);
  } else {
    initCartGuidance();
  }
})();
